import mutations from './mutations';
import actions from './actions';

const eventMembersState = {
  eventMembers: [],
  isEventMembersLoading: false,
  eventMembersCount: 0
};

export const defaultState = () => ({
  ...eventMembersState
});

const state = defaultState();

export default {
  getters: {},
  actions,
  mutations,
  state,
  namespaced: true
};
